import React, { useState } from 'react';
import { Typography, Box, Divider } from '@mui/material';
import { ProSidebar, Menu, MenuItem } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchoolIcon from '@mui/icons-material/School';
import BusinessIcon from '@mui/icons-material/Business';
import MapIcon from '@mui/icons-material/Map';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import GroupIcon from '@mui/icons-material/Group';
import CategoryIcon from '@mui/icons-material/Category';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ClassIcon from '@mui/icons-material/Class';
import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Item = ({
  title,
  to,
  icon,
  selected,
  setSelected,
  onClick,
  isCollapsed
}) => (
  <MenuItem
    active={selected === title}
    style={{
      color: selected === title ? '#007bff' : '#15175a',
      background: selected === title ? '#f0f4ff' : 'transparent',
      borderRadius: '8px',
      margin: '8px 0',
      transition: 'background 0.3s, color 0.3s'
    }}
    onClick={() => {
      setSelected(title);
      if (onClick) onClick();
    }}
    icon={icon}
  >
    {!isCollapsed && (
      <Typography sx={{ fontWeight: selected === title ? 'bold' : 'normal' }}>
        {title}
      </Typography>
    )}
    <Link to={to} />
  </MenuItem>
);
const AdminSideBarItems = ({ selected, setSelected, onLogout }) => {
  const { t } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <ProSidebar
        collapsed={isCollapsed}
        style={{
          backgroundColor: '#f9f9f9',
          color: '#333333',
          borderRadius: '12px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden'
        }}
      >
        <Menu iconShape="circle">
          <Item
            title={t('adminDashboard.homePage')}
            to="/"
            icon={<DashboardIcon />}
            selected={selected}
            setSelected={setSelected}
          />

          <Divider sx={{ backgroundColor: '#ccc', margin: '8px 0' }} />

          <Typography
            variant="h6"
            color="#555555"
            sx={{
              m: '10px 0 0 16px',
              textTransform: 'uppercase',
              fontSize: '14px',
              display: isCollapsed ? 'none' : 'block'
            }}
          >
            {t('adminDashboard.administration')}
          </Typography>

          <Item
            title={t('adminDashboard.students')}
            to="/manageStudent"
            icon={<SchoolIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.schools')}
            to="/schools"
            icon={<BusinessIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.locations')}
            to="/locations"
            icon={<MapIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />

          <Item
            title={t('adminDashboard.categories')}
            to="/categories"
            icon={<CategoryIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.roles')}
            to="/roles"
            icon={<SupervisorAccountIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.users')}
            to="/users"
            icon={<GroupIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.competitionModes')}
            to="/competition-modes"
            icon={<SportsEsportsIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />

          <Divider sx={{ backgroundColor: '#ccc', margin: '8px 0' }} />

          <Typography
            variant="h6"
            color="#555555"
            sx={{
              m: '10px 0 0 16px',
              textTransform: 'uppercase',
              fontSize: '14px',
              display: isCollapsed ? 'none' : 'block'
            }}
          >
            {t('adminDashboard.review')}
          </Typography>

          <Item
            title={t('adminDashboard.manageSolutions')}
            to="/manage-solutions"
            icon={<AssignmentTurnedInIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.reviewSchools')}
            to="/review-schools"
            icon={<ClassIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.verifyReviews')}
            to="/verify-all"
            icon={<ManageAccountsIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.resultsByGrade')}
            to="/results-by-grade"
            icon={<ClassIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.complaints')}
            to="/complaints-admin-page"
            icon={<FeedbackOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />

          <Divider sx={{ backgroundColor: '#ccc', margin: '8px 0' }} />

          <Typography
            variant="h6"
            color="#555555"
            sx={{
              m: '10px 0 0 16px',
              textTransform: 'uppercase',
              fontSize: '14px',
              display: isCollapsed ? 'none' : 'block'
            }}
          >
            {t('adminDashboard.reports')}
          </Typography>

          <Item
            title={t('adminDashboard.resultsStatistics')}
            to="/admin-stat-result"
            icon={<BarChartIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.genderStatistics')}
            to="/statisticByGender"
            icon={<PieChartIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
          <Item
            title={t('adminDashboard.languageStatistics')}
            to="/statisticByLanguage"
            icon={<PieChartIcon />}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />

          <Divider sx={{ backgroundColor: '#ccc', margin: '8px 0' }} />

          <Typography
            variant="h6"
            color="#555555"
            sx={{
              m: '10px 0 0 16px',
              textTransform: 'uppercase',
              fontSize: '14px',
              display: isCollapsed ? 'none' : 'block'
            }}
          >
            {t('adminDashboard.other')}
          </Typography>

          <Box flexGrow={1} />

          <Item
            title={t('adminDashboard.logout')}
            to="#"
            icon={<ExitToAppIcon />}
            onClick={onLogout}
            selected={selected}
            setSelected={setSelected}
            isCollapsed={isCollapsed}
          />
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default AdminSideBarItems;
